import { ReportUploadPanel } from "@/components/report_upload_panel"

interface CandsUploadSectionProps {
  integrationId: string
  onUploaded: () => void
}

/** Upload the C&S Check Cover Sheets report from the vendor portal; queues a `sync-cands` job. */
export function CandsUploadSection({ integrationId, onUploaded }: CandsUploadSectionProps) {
  return (
    <ReportUploadPanel
      endpoint="/api/admin/cands/upload"
      fields={{ integration_id: integrationId }}
      accept={{
        "text/csv": [".csv"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      }}
      dropLabel="Drag and drop the Check Cover Sheets report"
      formatsLabel=".csv or .xlsx"
      successMessage={() => ({
        title: "Upload received",
        description: "Your C&S deductions will sync in the background.",
      })}
      onUploaded={onUploaded}>
      <div class="rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900 space-y-2">
        <p>The Check Cover Sheet report says what each C&amp;S deduction is for. To export it:</p>
        <ol class="list-decimal list-outside space-y-1 ml-5">
          <li>
            Log in to the{" "}
            <a
              href="https://vendorportal.cswg.com/"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-blue-700">
              C&amp;S Vendor Portal
            </a>
            .
          </li>
          <li>
            Go to <strong>Reports</strong> → <strong>Check Cover Sheets Dashboard</strong>.
          </li>
          <li>Download the report as CSV or Excel.</li>
        </ol>
      </div>
    </ReportUploadPanel>
  )
}
